import * as React from 'react';
import './Slideshow.css';

interface SlideshowMenu {
  image: string;
  firstLine: {
    __html: string
  };
  secondLine: {
    __html: string
  };
}

export interface SlideshowState {
  slides: SlideshowMenu[];
  selectedSlide: number;
}

class Slideshow extends React.PureComponent<{}, SlideshowState> {

  constructor(props: React.ReactPropTypes) {
    super(props);

    this.state = {
      slides: [
        {
          image: 'assets/images/slideshow/slideshow-1.jpg',
          firstLine: { __html: `Say hello to<span>ProEma</span>` },
          secondLine: { __html: `Our Charity helps empowers adolescent girls and young women in Timor-Leste<br/>through training and education` }
        },
        {
          image: 'assets/images/slideshow/slideshow-2.jpg',
          firstLine: { __html: `Say hello to<span>ProEma</span>` },
          secondLine: { __html: `Our Charity helps empowers adolescent girls and young women in Timor-Leste<br/>through training and education` }
        },
        {
          image: 'assets/images/slideshow/slideshow-3.jpg',
          firstLine: { __html: `Say hello to<span>ProEma</span>` },
          secondLine: { __html: `Our Charity helps empowers adolescent girls and young women in Timor-Leste<br/>through training and education` }
        }
      ],
      selectedSlide: 0
    };
    this.tick = this.tick.bind(this);
    setInterval(this.tick, 10000);
  }

  tick() {
    this.setState({ selectedSlide: (this.state.selectedSlide + 1) % this.state.slides.length });
  }

  render(): JSX.Element {

    return (
      <section id="slideshow" className="slideshow">
        <div id="main-slideshow" className="main-slideshow">
          <div className="item">
            <img src={this.state.slides[this.state.selectedSlide].image} alt="Slider 1" />
            <div className="slide-caption">
              <h2 className="slide1anim1" dangerouslySetInnerHTML={this.state.slides[this.state.selectedSlide].firstLine} />
              <h3 className="slide1anim2" dangerouslySetInnerHTML={this.state.slides[this.state.selectedSlide].secondLine} />
              <a href="/Sponsorship" className="btn btn-slideshow slide1anim3">Sponsor now</a>
            </div>
          </div>
        </div>
      </section >);
  }
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/components/Slideshow.tsx